/**
 * DUNAMIS WEAR — Product FAQ tabs
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-faq-tabs]').forEach(function (tablist) {
    var section = tablist.closest('.product-faq');
    if (!section) return;

    var tabs = tablist.querySelectorAll('[data-faq-tab]');
    var panels = section.querySelectorAll('[data-faq-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-faq-tab');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-faq-panel') === id;
          panel.classList.toggle('is-active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      });
    });
  });
})();
